/**
 * お問い合わせ項目セレクト変更時にページ遷移
 *
 * 4つのフォーム（purchase, sale, after-contract, partnership）共通。
 * カスタムセレクト（_select.js）が native select に change イベントを
 * 発火するため、そのイベントをリッスンして対応ページへ遷移する。
 */
const CATEGORY_ROUTES = {
    purchase: '/contact/purchase',
    sale: '/contact/sale',
    'after-contract': '/contact/after-contract',
    partnership: '/contact/partnership',
};

const PAGE_IDS = ['page-purchase', 'page-sale', 'page-after-contract', 'page-partnership'];

function main() {
    const page = PAGE_IDS.find((id) => document.getElementById(id));
    if (!page) return;

    const categorySelect = document.getElementById('category');
    if (!categorySelect) return;

    categorySelect.addEventListener('change', () => {
        const url = CATEGORY_ROUTES[categorySelect.value];
        if (url) {
            window.location.href = url;
        }
    });
}

export default main;
